function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}
export default {
  created () {
    const title = getTitle(this)
    if (title) {
      const { VUE_APP_TITLE } = process.env
      document.title = `${title} | ${VUE_APP_TITLE}`
    }
  }
}
